<div class="column" [class.fade-left]="fadeLeft$ | async" [class.fade-left-reverse]="fadeLeftReverse$ | async"
     [class.fade-right]="fadeRight$ | async" [class.fade-right-reverse]="fadeRightReverse$ | async">

  <strong class="margin-top">Choisissez la dynamique de votre parcours.</strong>
  <app-dynamics *ngIf="thematic" [thematic]="thematic" [canValidate]="true" />
</div>
